import QuestionPopover from '@/uikit/QuestionPopover.vue';
import { defineComponent } from '@vue/composition-api';
export default defineComponent({
    name: 'ServiceList',
    components: {
        QuestionPopover
    },
    props: {
        item: {
            type: Object,
            default: () => { }
        },
        type: {
            type: String,
            default: ''
        },
        modelPropName: {
            type: String,
            default: ''
        }
    }
});
